import * as React from 'react';

import { ThreeManager } from 'franke-threejs-view';
import { ConfigurationModel, TroughModel, PlateBuilder, Configuration } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';

import './ThreeJsPartial.scss';
import { connect } from 'react-redux';
import { RequestApiResult } from 'loopback-react-request';
import Configuration3dAlert from '../Alerts/Configuration3dAlert';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export interface ThreeJsPartialProps {
  plateBuilder: GlobalPrivateState['plateBuilder'];
  configuration: RequestApiResult<ConfigurationModel>;
  trough: RequestApiResult<TroughModel>;
  threeCanvasRef: any;
}

export interface ThreeJsPartialState {
  isInitialized: boolean;
}

export class ThreeJsPartialPartial extends React.Component<ThreeJsPartialProps, ThreeJsPartialState> {
  container: HTMLDivElement | null;
  threeManager: any;

  constructor(props: ThreeJsPartialProps) {
    super(props);

    this.container = null;
    this.state = {
      isInitialized: false,
    };

    this.updateThreeManager = this.updateThreeManager.bind(this);
    this.initThreeManager = this.initThreeManager.bind(this);
  }

  componentDidMount() {
    // window.addEventListener('resize', this.updateThreeManager);

    const configuration = this.props.configuration.result;
    const trough = this.props.trough.result;

    if (!configuration || !trough) {
      return;
    }

    if (!this.state.isInitialized) {
      this.initThreeManager();
    }

  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.updateThreeManager);
  }
  
  componentDidUpdate() {
    const configuration = this.props.configuration.result;
    const trough = this.props.trough.result;

    if (!configuration || !trough) {
      return;
    }

    if (!this.state.isInitialized) {
      this.initThreeManager();
    }
    if (this.state.isInitialized) {
      this.updateThreeManager();
    }
  }

  get dimensions(): {height: number, width: number} {
    const parent = this.container;

    if (parent) {
      return {
        width: parent.scrollWidth,
        height: parent.scrollHeight,
      };
    }
    return {
      width: 400,
      height: 400,
    };
  }

  public render() {
    return (
      <div className="partial-three d-flex justify-content w-100 vh-100">
        {this.props.configuration.result && this.props.configuration.result.selectedTrough ? (
          <>
            <LoadingSpinner />
            <div
              id="threejs"
              className="w-100 h-100"
              ref={node => this.container = node}
            />
          </>
        ) : (
          <div className="start-screen w-100">
            <Configuration3dAlert />
            <img className="img-fluid start-screen-img" src={process.env.PUBLIC_URL + '/img/backgrounds/startscreen-grafik.jpg'} />
          </div>
        )}
      </div>
    );
  }
  
  private initThreeManager() {
    if (!this.threeManagerData) { return; }

    if (!this.threeManager) {
      this.threeManager = new ThreeManager(
        this.threeManagerData, 
        { 
          width: this.dimensions.width, 
          height: this.dimensions.height
        }, 
        this.container
      );
    }

    if (this.container && this.container) {
      this.threeManager.update(this.threeManagerData);
    }
    
    this.setState({isInitialized: true});
  }

  private updateThreeManager() {
    if (this.container && this.threeManagerData) {
			console.log('this.threeManagerData', this.threeManagerData);
      this.threeManager.update(this.threeManagerData, this.dimensions);
    }
  }

  private get threeManagerData() {
    if (this.props.plateBuilder) {
      console.log(JSON.parse(JSON.stringify(this.props.plateBuilder.components)));
      return JSON.parse(JSON.stringify(this.props.plateBuilder.components));
    } else {
      return;
    }
  }
}

export const ThreeJsPartial = connect((state: GlobalPrivateState) => ({
  plateBuilder: state.plateBuilder,
  configuration: state.configuration,
  trough: state.trough,
}))(ThreeJsPartialPartial);

export default ThreeJsPartial;
